export const REQUEST_TIMEOUT = "REQUEST_TIMEOUT";
export const RESPONSE_500 = "RESPONSE_500";

export const SERVER_INTERRUPT_MESSAGES = {
    [REQUEST_TIMEOUT] : "دسترسی به سرور مقدور نمی باشد. اتصال به اینترنت را چک کنید",
    [RESPONSE_500] : "در ارتباط با سرور مشکلی پیش آمده‌است. لطفا مجددا تلاش کنید.",
};